import React 		from 'react'
import classnames 	from 'classnames'
import {
	isFinite
} from 'lodash'

class SectionSpacer extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			space
		} = this.props

		return !isFinite(space) || space > 0 ? <div
			className={ classnames('sectionSpacer', {
				[`sectionSpacer--p-${ ('' + space).replace('.', 'x') }`]: isFinite(space) && space > 0 && space !== 1
			}) }
			/> : null
	}
}

export default SectionSpacer